import i18n from './../../i18n';
import { origin, isBOE } from 'conf';
import { showToast } from './../../utils/msgUtil';
import { UpdateBA, OauthTools } from '@ad/authorization-i18n-sdk';
import store from './../../store/index';

import { BASource, TeaConfig } from './../../const/media';
import { trackEvent } from './../../tea-tracker';
import { computed } from 'vue-demi';
import accountState from './../../store/modules/account/index';

enum OauthEvent {
  bind = 'bind',
  close = 'close'
}
export const useBAUpgrade = (successCallback: (data: any) => void) => {
  const updateBASDK = new UpdateBA({
    isBOE,
    id: 'update_ba_container',
    lang: i18n.locale || 'en',
    onError: (e: any) => {
      showToast(e);
      trackEvent('adp_waplite_impression', {
        [TeaConfig.TTBA_UPGRADE.FAILED]: typeof e === 'string' ? e : JSON.stringify(e),
      });
    },
    onSuccess: successCallback,
    source: BASource.TT4B_MOBILE_LITE_SWITCHED,
  });
  updateBASDK.render();
};

export const useTikTokAuth = async (successCallback: (data?: any) => void, nonIdentity = true): Promise<void> => {
  const aadvid = computed(() => accountState.getters.adverId(accountState.state))

  const sso = new OauthTools({
    aid: 1583,
    lang: i18n.locale || 'en',
    source: 'mobile lite',
    sharkReport: true,
    security: true,
    notifyUrl: `${origin}/ac/api/v1/oauth/bind_tt_oauth`, // 通知给ads平台授权关系有变动
    extraParam: {
      aadvid: aadvid.value, //页面能拿到aadvid的尽量传进来
      has_optimization: false // identity功能升级后（即ttbc和ttba合并后）可以将这个值改为true，没升级前可以不传
    }
  });
  const targetWindow = await sso.jumpOauth({
    scence: 'ttam_mobile_lite_bind',
    email: store.state.account.coreUserInfo?.core_user?.email,
    mobile: store.state.account.coreUserInfo?.core_user?.mobile,
  });
  const callback = (event: MessageEvent) => {
    if (event.origin !== origin || event.data?.module !== 'oauth') {
      return;
    }
    if (event.data?.event === OauthEvent.bind && event.data?.code === 0) {
      successCallback();
      targetWindow?.close();
    } else {
      // 如果授权失败没有自动redirect回来，用户就不感知这个报错提示
      const msg = event.data?.msg || i18n.t('fastcreation_identity_bind_error');
      showToast(msg);
      trackEvent('adp_waplite_impression', {
        [nonIdentity ? TeaConfig.TT_AUTH.FAILED : TeaConfig.TT_ANOTHER_AUTH.FAILED]: msg,
      });
    }
    window.removeEventListener('message', callback);
  };
  window.addEventListener('message', callback);
};

